import { appConfig } from '../init/getAppConfig';
import { EnvType } from '../app/types/enum';

export function getAddressApiKey(): string {
  if (
    appConfig.envType == EnvType.prod ||
    appConfig.envType == EnvType.staging
  ) {
    return 'WH97-XN17-HU66-RG45';
  }
  return 'CJ25-DP94-RB49-CE16';
}
